var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.item.title))])],1),_c('v-list-item-action',[_c('v-btn',{attrs:{"disabled":_vm.processing,"loading":_vm.processing,"icon":""},on:{"click":_vm.releaseItemBlock}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("mdi-close-circle")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }